// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-tournaments-teams-summary-modal__container .modal2__content{
    overflow: unset;
}

.profile-tournaments-teams-summary-modal__unlock-values__action {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--new-informative-banner-bg-color);
    padding: 10px;
    border-radius: 4px;
    margin: 16px 24px;
}

.profile-tournaments-teams-summary-modal__unlock-values__action .primary-button {
    padding: 8px 12px;
}

.profile-tournaments-teams-summary-modal__unlock-values__text .hubicon-info::before {
    color: var(--new-informative-banner-color);
}

.profile-tournaments-teams-summary-modal__unlock-values__text .baloa-normal-medium {
    display: flex;
    align-items: center;
    justify-content: flex-start; 
    gap: 10px;  
}

.profile-tournaments-teams-summary-modal__unlock-values__text .baloa-normal-medium .hubicon-award_star {
    font-size: 22px;
}

.profile-tournaments-teams-summary-modal__table {
    margin: 14px 0;
}

.profile-tournaments-teams-summary-modal__table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 10px 6px 10px;
    background-color: var(--new-background-color);
    border-radius: 4px;
}
.profile-tournaments-teams-summary-modal__table-header-col {
    width: 50%;
    display: grid;
    grid-template-columns: repeat(9, 1fr);
    grid-gap: 2px;
}

.profile-tournaments-teams-summary-modal__table-header-col .baloa-normal-medium {
    color: var(--primary-dark-color);
    position: relative;
    text-align: center;
}

.profile-tournaments-teams-summary-modal__table-header-col .hubicon-titular,
.profile-tournaments-teams-summary-modal__table-header-col .hubicon-timer,
.profile-tournaments-teams-summary-modal__table-header-col .hubicon-goalkeeper,
.profile-tournaments-teams-summary-modal__table-header-col .hubicon-assists,
.profile-tournaments-teams-summary-modal__table-header-col .icon-ball {
    font-size: 24px;
    color: var(--primary-dark-color);
    position: relative;
    text-align: center;
}

.profile-tournaments-teams-summary-modal__table-header-col__yellow-card {
    width: 18px;
    height: 24px;
    background-color: var(--new-yellow-warning-color);
}
.profile-tournaments-teams-summary-modal__table-header-col__red-card {
    width: 18px;
    height: 24px;
    background-color: var(--error-color);
}

.profile-tournaments-teams-summary-modal__tooltip{
    visibility: hidden;
    width: 100px;
    background-color: var(--primary-dark-color);
    color: var(--white-color);
    text-align: center;
    border-radius: var(--space-and-half);
    padding: 5px 0;
    box-shadow: 0px 1px 2px;

    /* Position the tooltip */
    position: absolute;
    z-index: 1000;
    bottom: 40px;
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: bold;
    font-size: var(--space-half-quarter);
    line-height: var(--space);
    right: -45px;
}

.profile-tournaments-teams-summary-modal__table-header-col .played_games:hover,
.profile-tournaments-teams-summary-modal__table-header-col .hubicon-titular:hover,
.profile-tournaments-teams-summary-modal__table-header-col .hubicon-timer:hover,
.profile-tournaments-teams-summary-modal__table-header-col .hubicon-goalkeeper:hover,
.profile-tournaments-teams-summary-modal__table-header-col .hubicon-assists:hover,
.profile-tournaments-teams-summary-modal__table-header-col .icon-ball:hover,
.profile-tournaments-teams-summary-modal__table-header-col .goals:hover,
.profile-tournaments-teams-summary-modal__table-header-col .profile-tournaments-table__table-header-col__yellow-card:hover,
.profile-tournaments-teams-summary-modal__table-header-col .profile-tournaments-table__table-header-col__red-card:hover,
.profile-tournaments-teams-summary-modal__table-header-col .profile-tournaments-table__table-header-col__blue-card:hover {
    cursor: pointer;
}

.profile-tournaments-teams-summary-modal__table-header-col .played_games:hover .profile-tournaments-teams-summary-modal__tooltip,
.profile-tournaments-teams-summary-modal__table-header-col .hubicon-titular:hover .profile-tournaments-teams-summary-modal__tooltip,
.profile-tournaments-teams-summary-modal__table-header-col .hubicon-timer:hover .profile-tournaments-teams-summary-modal__tooltip,
.profile-tournaments-teams-summary-modal__table-header-col .hubicon-goalkeeper:hover .profile-tournaments-teams-summary-modal__tooltip,
.profile-tournaments-teams-summary-modal__table-header-col .hubicon-assists:hover .profile-tournaments-teams-summary-modal__tooltip,
.profile-tournaments-teams-summary-modal__table-header-col .icon-ball:hover .profile-tournaments-teams-summary-modal__tooltip,
.profile-tournaments-teams-summary-modal__table-header-col .goals:hover .profile-tournaments-teams-summary-modal__tooltip,
.profile-tournaments-teams-summary-modal__table-header-col .profile-tournaments-table__table-header-col__yellow-card:hover .profile-tournaments-teams-summary-modal__tooltip,
.profile-tournaments-teams-summary-modal__table-header-col .profile-tournaments-table__table-header-col__red-card:hover .profile-tournaments-teams-summary-modal__tooltip,
.profile-tournaments-teams-summary-modal__table-header-col .profile-tournaments-table__table-header-col__blue-card:hover .profile-tournaments-teams-summary-modal__tooltip{

    visibility: visible;    
}

.profile-tournaments-teams-summary-modal__table-body {
    margin-top: 16px;
}

.profile-tournaments-teams-summary-modal__table-body-col__img img {
    width: 44px;
    height: 44px;
    border-radius: 50%;        
}
.profile-tournaments-teams-summary-modal__table-body-col__img .icon-ball {
    color: var(--white-color );
    font-size: 36px;
    border-radius: 50%;
    padding: 4px;    
}

.profile-tournaments-teams-summary-modal__table-body-col {
    width: 50%;
}

.profile-tournaments-teams-summary-modal__table-body-col.summary-info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.profile-tournaments-teams-summary-modal__table-body__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    padding: 0 10px;
}

.profile-tournaments-teams-summary-modal__table-body-col__info__labels {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 4px;
    gap:4px ;
}
.profile-tournaments-teams-summary-modal__table-body-col__info .baloa-normal-medium {
    color: var(--primary-dark-color);
}

.profile-tournaments-teams-summary-modal__table-body-col__info__labels .baloa-table-column {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
    padding: 3px 6px;
    border-radius: 25px;
    background-color: var(--new-background-color);
    border: 1px solid var(--new-gray-color );
    white-space: nowrap;
}

.profile-tournaments-teams-summary-modal__table-body-col__info {
    margin-left: 4px;
}
.profile-tournaments-teams-summary-modal__table-body-col.summary-values {
    display: grid;
    grid-template-columns: repeat(9, 1fr);
    grid-gap: 2px;
}

.profile-tournaments-teams-summary-modal__table-body-col.summary-values .baloa-normal-medium {
    color: var(--primary-dark-color);
    text-align: center;
}

.profile-tournaments-teams-summary-modal__table-body-col.summary-values .baloa-normal-medium.locked_values {
    filter: blur(4px);
}

.profile-tournaments-teams-summary-modal__victories__table {
    margin: 14px 0;
}

.profile-tournaments-teams-summary-modal__victories__table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 48px 6px 10px;
    background-color: var(--new-background-color);
    border-radius: 4px;
}

.profile-tournaments-teams-summary-modal__victories__table-header .baloa-normal-medium {
    color: var(--primary-dark-color);
}

.profile-tournaments-teams-summary-modal__victories__table-body {
    margin-top: 16px;
}

.profile-tournaments-teams-summary-modal__victories__table-body__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    margin-right: 16px;
}

.profile-tournaments-teams-summary-modal__victories__table-body-col {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.profile-tournaments-teams-summary-modal__victories__table-body-col__img img {
    width: 44px;
    height: 44px;
    border-radius: 50%;        
}

.profile-tournaments-teams-summary-modal__victories__table-body-col__img .icon-ball {
    color: var(--white-color );
    font-size: 36px;
    border-radius: 50%;
    padding: 4px;    
}

.profile-tournaments-teams-summary-modal__victories__table-body-col.baloa-normal-medium {
    color: var(--primary-dark-color);
}

.profile-tournaments-teams-summary-modal__victories__table-body-col.baloa-normal-medium.locked_values {
    filter: blur(4px);
}

.profile-tournaments-teams-summary-modal__victories__table-body-col__info .baloa-normal-medium {
    color: var(--primary-dark-color);
}
.profile-tournaments-teams-summary-modal__victories__table-body-col__info {
    margin-left: 4px;
}

.profile-tournaments-teams-summary-modal__victories__table-body-col__info__labels {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 4px;
    gap:4px ;
}
.profile-tournaments-teams-summary-modal__victories__table-body-col__info__labels .baloa-table-column {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
    padding: 3px 6px;
    border-radius: 25px;
    background-color: var(--new-background-color);
    border: 1px solid var(--new-gray-color );
}

.profile-tournaments-teams-summary-modal__table-container {
    padding: 0 24px;
}

.profile-tournaments-teams-summary-modal__loader {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.profile-tournaments-teams-summary-modal__loader img {
    width: 32px;
}

.profile-tournaments-teams-summary-modal__table-body .infinite-scroll-component::-webkit-scrollbar {
    display: none; 
}

.profile-tournaments-teams-summary-modal__table-body .infinite-scroll-component:hover::-webkit-scrollbar {
    display: initial;
}

.profile-tournaments-teams-summary-modal__table-body .infinite-scroll-component::-webkit-scrollbar:vertical {
    width:10px;
}

.profile-tournaments-teams-summary-modal__table-body .infinite-scroll-component::-webkit-scrollbar:horizontal {
    height: 10px;
}

.profile-tournaments-teams-summary-modal__table-body .infinite-scroll-component::-webkit-scrollbar-thumb {
    background-color: #797979;
    border-radius: 20px;
    border: 2px solid #f1f2f3;
}

.profile-tournaments-teams-summary-modal__table-body-col .c1{
    grid-column: 1;
}

.profile-tournaments-teams-summary-modal__table-body-col .c2{
    grid-column: 2;
}

.profile-tournaments-teams-summary-modal__table-body-col .c3{
    grid-column: 3;
}
.profile-tournaments-teams-summary-modal__table-body-col .c4{
    grid-column: 4;
}
.profile-tournaments-teams-summary-modal__table-body-col .c5{
    grid-column: 5;
}
.profile-tournaments-teams-summary-modal__table-body-col .c6{
    grid-column: 6;
}
.profile-tournaments-teams-summary-modal__table-body-col .c7{
    grid-column: 7;
}
.profile-tournaments-teams-summary-modal__table-body-col .c8{
    grid-column: 8
}
.profile-tournaments-teams-summary-modal__table-body-col .c9{
    grid-column: 9
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 
    .profile-tournaments-teams-summary-modal__container .modal2__container {
        width: 100%;
        margin: 0;
        border-radius: 0;
        max-height: 100%;
        height: 100%;
    }  
    
    .profile-tournaments-teams-summary-modal__container .modal2__content {
        height: 100%;
        background: var(--new-background-color);
    }

    .profile-tournaments-teams-summary-modal__unlock-values__action {
        position: absolute;
        bottom: 0;
        width: 100%;
        border: 8px solid var(--white-color);
        margin: 0;
    }

    .profile-tournaments-teams-summary-modal__table-body-col__img img {
        width: 24px;
        height: 24px;
    }

    .profile-tournaments-teams-summary-modal__table-body-col__img .icon-ball {
        font-size: 20px;
        padding: 2px;    
    }

    .profile-tournaments-teams-summary-modal__table-body-col__info .baloa-normal-medium {
        font-size: 14px;
        line-height: 16px;
        white-space: nowrap;        
        width: 130px; 
        white-space: nowrap; 
        overflow: hidden; 
        text-overflow: ellipsis; 
    }

    .profile-tournaments-teams-summary-modal__table-header-col .baloa-normal-medium {
        font-size: 12px;
        line-height: 14px;
        font-weight: var(--font-regular);
    }

    .profile-tournaments-teams-summary-modal__table-header-col .hubicon-titular,
    .profile-tournaments-teams-summary-modal__table-header-col .hubicon-timer,
    .profile-tournaments-teams-summary-modal__table-header-col .hubicon-goalkeeper,
    .profile-tournaments-teams-summary-modal__table-header-col .hubicon-assists,
    .profile-tournaments-teams-summary-modal__table-header-col .icon-ball {
        font-size: 12px;
    }

    .profile-tournaments-teams-summary-modal__table-header-col__yellow-card,
    .profile-tournaments-teams-summary-modal__table-header-col__red-card {
        width: 10px;
        height: 14px;
    }

    .profile-tournaments-teams-summary-modal__table-body-col__info__labels .baloa-table-column {
        font-size: 9px;
        line-height: 11px;
        padding: 2px 4px;
    }

    .profile-tournaments-teams-summary-modal__table-body-col.summary-values .baloa-normal-medium {
        font-size: 13px;
        line-height: 15px;
    }   
    
    .profile-tournaments-teams-summary-modal__table-body__container {
        padding-left: 0;
        padding-right: 10px;
    }

    .profile-tournaments-teams-summary-modal__table-body-col__info__labels {
        gap: 2px;
    }

    .profile-tournaments-teams-summary-modal__table-header-col.baloa-normal-medium {
        font-size: 13px;
        line-height: 15px;
    }

    .profile-tournaments-teams-summary-modal__victories__table-header .baloa-normal-medium {
        font-size: 13px;
        line-height: 15px;
    }

    .profile-tournaments-teams-summary-modal__victories__table-body-col__img img {
        width: 30px;
        height: 30px;
    }

    .profile-tournaments-teams-summary-modal__victories__table-body-col__img .icon-ball {
        font-size: 24px;
        padding: 3px;    
    }

    .profile-tournaments-teams-summary-modal__victories__table-body-col__info .baloa-normal-medium {
        font-size: 14px;
        line-height: 16px;
    }

    .profile-tournaments-teams-summary-modal__victories__table-body-col__info__labels .baloa-table-column {
        font-size: 9px;
        line-height: 11px;
        padding: 2px 4px;
    }

    .profile-tournaments-teams-summary-modal__victories__table-body-col.baloa-normal-medium {
        font-size: 14px;
        line-height: 16px;
    }

    .profile-tournaments-teams-summary-modal__table-container {
        padding: 0 8px;
        background-color: var(--white-color);
    }

    .profile-tournaments-teams-summary-modal__victories__table-header {        
        padding: 6px 24px 6px 10px;        
    }

    .profile-tournaments-teams-summary-modal__unlock-values__text .baloa-normal-medium .hubicon-award_star {
        font-size: 18px;
    }

    .profile-tournaments-teams-summary-modal__unlock-values__text .baloa-normal-medium {
        font-size: 13px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-tournaments-teams-summary-modal/ProfileTournamentsTeamsSummaryModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wDAAwD;IACxD,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,0BAA0B;IAC1B,6CAA6C;IAC7C,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,aAAa;IACb,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;;;;IAKI,eAAe;IACf,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iDAAiD;AACrD;AACA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,2CAA2C;IAC3C,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;IACd,uBAAuB;;IAEvB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;IACjB,oCAAoC;IACpC,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;;;;;;;;;IAUI,eAAe;AACnB;;AAEA;;;;;;;;;;;IAWI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,QAAQ;AACZ;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,6CAA6C;IAC7C,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,0BAA0B;IAC1B,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,QAAQ;AACZ;AACA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,6CAA6C;IAC7C,wCAAwC;AAC5C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI;AACJ;AACA;IACI;AACJ;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,WAAW;QACX,SAAS;QACT,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,uCAAuC;IAC3C;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,oCAAoC;QACpC,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;QACnB,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gCAAgC;IACpC;;IAEA;;;;;QAKI,eAAe;IACnB;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,oCAAoC;IACxC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".profile-tournaments-teams-summary-modal__container .modal2__content{\n    overflow: unset;\n}\n\n.profile-tournaments-teams-summary-modal__unlock-values__action {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: var(--new-informative-banner-bg-color);\n    padding: 10px;\n    border-radius: 4px;\n    margin: 16px 24px;\n}\n\n.profile-tournaments-teams-summary-modal__unlock-values__action .primary-button {\n    padding: 8px 12px;\n}\n\n.profile-tournaments-teams-summary-modal__unlock-values__text .hubicon-info::before {\n    color: var(--new-informative-banner-color);\n}\n\n.profile-tournaments-teams-summary-modal__unlock-values__text .baloa-normal-medium {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start; \n    gap: 10px;  \n}\n\n.profile-tournaments-teams-summary-modal__unlock-values__text .baloa-normal-medium .hubicon-award_star {\n    font-size: 22px;\n}\n\n.profile-tournaments-teams-summary-modal__table {\n    margin: 14px 0;\n}\n\n.profile-tournaments-teams-summary-modal__table-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 6px 10px 6px 10px;\n    background-color: var(--new-background-color);\n    border-radius: 4px;\n}\n.profile-tournaments-teams-summary-modal__table-header-col {\n    width: 50%;\n    display: grid;\n    grid-template-columns: repeat(9, 1fr);\n    grid-gap: 2px;\n}\n\n.profile-tournaments-teams-summary-modal__table-header-col .baloa-normal-medium {\n    color: var(--primary-dark-color);\n    position: relative;\n    text-align: center;\n}\n\n.profile-tournaments-teams-summary-modal__table-header-col .hubicon-titular,\n.profile-tournaments-teams-summary-modal__table-header-col .hubicon-timer,\n.profile-tournaments-teams-summary-modal__table-header-col .hubicon-goalkeeper,\n.profile-tournaments-teams-summary-modal__table-header-col .hubicon-assists,\n.profile-tournaments-teams-summary-modal__table-header-col .icon-ball {\n    font-size: 24px;\n    color: var(--primary-dark-color);\n    position: relative;\n    text-align: center;\n}\n\n.profile-tournaments-teams-summary-modal__table-header-col__yellow-card {\n    width: 18px;\n    height: 24px;\n    background-color: var(--new-yellow-warning-color);\n}\n.profile-tournaments-teams-summary-modal__table-header-col__red-card {\n    width: 18px;\n    height: 24px;\n    background-color: var(--error-color);\n}\n\n.profile-tournaments-teams-summary-modal__tooltip{\n    visibility: hidden;\n    width: 100px;\n    background-color: var(--primary-dark-color);\n    color: var(--white-color);\n    text-align: center;\n    border-radius: var(--space-and-half);\n    padding: 5px 0;\n    box-shadow: 0px 1px 2px;\n\n    /* Position the tooltip */\n    position: absolute;\n    z-index: 1000;\n    bottom: 40px;\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: bold;\n    font-size: var(--space-half-quarter);\n    line-height: var(--space);\n    right: -45px;\n}\n\n.profile-tournaments-teams-summary-modal__table-header-col .played_games:hover,\n.profile-tournaments-teams-summary-modal__table-header-col .hubicon-titular:hover,\n.profile-tournaments-teams-summary-modal__table-header-col .hubicon-timer:hover,\n.profile-tournaments-teams-summary-modal__table-header-col .hubicon-goalkeeper:hover,\n.profile-tournaments-teams-summary-modal__table-header-col .hubicon-assists:hover,\n.profile-tournaments-teams-summary-modal__table-header-col .icon-ball:hover,\n.profile-tournaments-teams-summary-modal__table-header-col .goals:hover,\n.profile-tournaments-teams-summary-modal__table-header-col .profile-tournaments-table__table-header-col__yellow-card:hover,\n.profile-tournaments-teams-summary-modal__table-header-col .profile-tournaments-table__table-header-col__red-card:hover,\n.profile-tournaments-teams-summary-modal__table-header-col .profile-tournaments-table__table-header-col__blue-card:hover {\n    cursor: pointer;\n}\n\n.profile-tournaments-teams-summary-modal__table-header-col .played_games:hover .profile-tournaments-teams-summary-modal__tooltip,\n.profile-tournaments-teams-summary-modal__table-header-col .hubicon-titular:hover .profile-tournaments-teams-summary-modal__tooltip,\n.profile-tournaments-teams-summary-modal__table-header-col .hubicon-timer:hover .profile-tournaments-teams-summary-modal__tooltip,\n.profile-tournaments-teams-summary-modal__table-header-col .hubicon-goalkeeper:hover .profile-tournaments-teams-summary-modal__tooltip,\n.profile-tournaments-teams-summary-modal__table-header-col .hubicon-assists:hover .profile-tournaments-teams-summary-modal__tooltip,\n.profile-tournaments-teams-summary-modal__table-header-col .icon-ball:hover .profile-tournaments-teams-summary-modal__tooltip,\n.profile-tournaments-teams-summary-modal__table-header-col .goals:hover .profile-tournaments-teams-summary-modal__tooltip,\n.profile-tournaments-teams-summary-modal__table-header-col .profile-tournaments-table__table-header-col__yellow-card:hover .profile-tournaments-teams-summary-modal__tooltip,\n.profile-tournaments-teams-summary-modal__table-header-col .profile-tournaments-table__table-header-col__red-card:hover .profile-tournaments-teams-summary-modal__tooltip,\n.profile-tournaments-teams-summary-modal__table-header-col .profile-tournaments-table__table-header-col__blue-card:hover .profile-tournaments-teams-summary-modal__tooltip{\n\n    visibility: visible;    \n}\n\n.profile-tournaments-teams-summary-modal__table-body {\n    margin-top: 16px;\n}\n\n.profile-tournaments-teams-summary-modal__table-body-col__img img {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;        \n}\n.profile-tournaments-teams-summary-modal__table-body-col__img .icon-ball {\n    color: var(--white-color );\n    font-size: 36px;\n    border-radius: 50%;\n    padding: 4px;    \n}\n\n.profile-tournaments-teams-summary-modal__table-body-col {\n    width: 50%;\n}\n\n.profile-tournaments-teams-summary-modal__table-body-col.summary-info {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n.profile-tournaments-teams-summary-modal__table-body__container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 16px;\n    padding: 0 10px;\n}\n\n.profile-tournaments-teams-summary-modal__table-body-col__info__labels {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin-top: 4px;\n    gap:4px ;\n}\n.profile-tournaments-teams-summary-modal__table-body-col__info .baloa-normal-medium {\n    color: var(--primary-dark-color);\n}\n\n.profile-tournaments-teams-summary-modal__table-body-col__info__labels .baloa-table-column {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n    padding: 3px 6px;\n    border-radius: 25px;\n    background-color: var(--new-background-color);\n    border: 1px solid var(--new-gray-color );\n    white-space: nowrap;\n}\n\n.profile-tournaments-teams-summary-modal__table-body-col__info {\n    margin-left: 4px;\n}\n.profile-tournaments-teams-summary-modal__table-body-col.summary-values {\n    display: grid;\n    grid-template-columns: repeat(9, 1fr);\n    grid-gap: 2px;\n}\n\n.profile-tournaments-teams-summary-modal__table-body-col.summary-values .baloa-normal-medium {\n    color: var(--primary-dark-color);\n    text-align: center;\n}\n\n.profile-tournaments-teams-summary-modal__table-body-col.summary-values .baloa-normal-medium.locked_values {\n    filter: blur(4px);\n}\n\n.profile-tournaments-teams-summary-modal__victories__table {\n    margin: 14px 0;\n}\n\n.profile-tournaments-teams-summary-modal__victories__table-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 6px 48px 6px 10px;\n    background-color: var(--new-background-color);\n    border-radius: 4px;\n}\n\n.profile-tournaments-teams-summary-modal__victories__table-header .baloa-normal-medium {\n    color: var(--primary-dark-color);\n}\n\n.profile-tournaments-teams-summary-modal__victories__table-body {\n    margin-top: 16px;\n}\n\n.profile-tournaments-teams-summary-modal__victories__table-body__container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 16px;\n    margin-right: 16px;\n}\n\n.profile-tournaments-teams-summary-modal__victories__table-body-col {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.profile-tournaments-teams-summary-modal__victories__table-body-col__img img {\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;        \n}\n\n.profile-tournaments-teams-summary-modal__victories__table-body-col__img .icon-ball {\n    color: var(--white-color );\n    font-size: 36px;\n    border-radius: 50%;\n    padding: 4px;    \n}\n\n.profile-tournaments-teams-summary-modal__victories__table-body-col.baloa-normal-medium {\n    color: var(--primary-dark-color);\n}\n\n.profile-tournaments-teams-summary-modal__victories__table-body-col.baloa-normal-medium.locked_values {\n    filter: blur(4px);\n}\n\n.profile-tournaments-teams-summary-modal__victories__table-body-col__info .baloa-normal-medium {\n    color: var(--primary-dark-color);\n}\n.profile-tournaments-teams-summary-modal__victories__table-body-col__info {\n    margin-left: 4px;\n}\n\n.profile-tournaments-teams-summary-modal__victories__table-body-col__info__labels {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin-top: 4px;\n    gap:4px ;\n}\n.profile-tournaments-teams-summary-modal__victories__table-body-col__info__labels .baloa-table-column {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n    padding: 3px 6px;\n    border-radius: 25px;\n    background-color: var(--new-background-color);\n    border: 1px solid var(--new-gray-color );\n}\n\n.profile-tournaments-teams-summary-modal__table-container {\n    padding: 0 24px;\n}\n\n.profile-tournaments-teams-summary-modal__loader {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n}\n\n.profile-tournaments-teams-summary-modal__loader img {\n    width: 32px;\n}\n\n.profile-tournaments-teams-summary-modal__table-body .infinite-scroll-component::-webkit-scrollbar {\n    display: none; \n}\n\n.profile-tournaments-teams-summary-modal__table-body .infinite-scroll-component:hover::-webkit-scrollbar {\n    display: initial;\n}\n\n.profile-tournaments-teams-summary-modal__table-body .infinite-scroll-component::-webkit-scrollbar:vertical {\n    width:10px;\n}\n\n.profile-tournaments-teams-summary-modal__table-body .infinite-scroll-component::-webkit-scrollbar:horizontal {\n    height: 10px;\n}\n\n.profile-tournaments-teams-summary-modal__table-body .infinite-scroll-component::-webkit-scrollbar-thumb {\n    background-color: #797979;\n    border-radius: 20px;\n    border: 2px solid #f1f2f3;\n}\n\n.profile-tournaments-teams-summary-modal__table-body-col .c1{\n    grid-column: 1;\n}\n\n.profile-tournaments-teams-summary-modal__table-body-col .c2{\n    grid-column: 2;\n}\n\n.profile-tournaments-teams-summary-modal__table-body-col .c3{\n    grid-column: 3;\n}\n.profile-tournaments-teams-summary-modal__table-body-col .c4{\n    grid-column: 4;\n}\n.profile-tournaments-teams-summary-modal__table-body-col .c5{\n    grid-column: 5;\n}\n.profile-tournaments-teams-summary-modal__table-body-col .c6{\n    grid-column: 6;\n}\n.profile-tournaments-teams-summary-modal__table-body-col .c7{\n    grid-column: 7;\n}\n.profile-tournaments-teams-summary-modal__table-body-col .c8{\n    grid-column: 8\n}\n.profile-tournaments-teams-summary-modal__table-body-col .c9{\n    grid-column: 9\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n    .profile-tournaments-teams-summary-modal__container .modal2__container {\n        width: 100%;\n        margin: 0;\n        border-radius: 0;\n        max-height: 100%;\n        height: 100%;\n    }  \n    \n    .profile-tournaments-teams-summary-modal__container .modal2__content {\n        height: 100%;\n        background: var(--new-background-color);\n    }\n\n    .profile-tournaments-teams-summary-modal__unlock-values__action {\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n        border: 8px solid var(--white-color);\n        margin: 0;\n    }\n\n    .profile-tournaments-teams-summary-modal__table-body-col__img img {\n        width: 24px;\n        height: 24px;\n    }\n\n    .profile-tournaments-teams-summary-modal__table-body-col__img .icon-ball {\n        font-size: 20px;\n        padding: 2px;    \n    }\n\n    .profile-tournaments-teams-summary-modal__table-body-col__info .baloa-normal-medium {\n        font-size: 14px;\n        line-height: 16px;\n        white-space: nowrap;        \n        width: 130px; \n        white-space: nowrap; \n        overflow: hidden; \n        text-overflow: ellipsis; \n    }\n\n    .profile-tournaments-teams-summary-modal__table-header-col .baloa-normal-medium {\n        font-size: 12px;\n        line-height: 14px;\n        font-weight: var(--font-regular);\n    }\n\n    .profile-tournaments-teams-summary-modal__table-header-col .hubicon-titular,\n    .profile-tournaments-teams-summary-modal__table-header-col .hubicon-timer,\n    .profile-tournaments-teams-summary-modal__table-header-col .hubicon-goalkeeper,\n    .profile-tournaments-teams-summary-modal__table-header-col .hubicon-assists,\n    .profile-tournaments-teams-summary-modal__table-header-col .icon-ball {\n        font-size: 12px;\n    }\n\n    .profile-tournaments-teams-summary-modal__table-header-col__yellow-card,\n    .profile-tournaments-teams-summary-modal__table-header-col__red-card {\n        width: 10px;\n        height: 14px;\n    }\n\n    .profile-tournaments-teams-summary-modal__table-body-col__info__labels .baloa-table-column {\n        font-size: 9px;\n        line-height: 11px;\n        padding: 2px 4px;\n    }\n\n    .profile-tournaments-teams-summary-modal__table-body-col.summary-values .baloa-normal-medium {\n        font-size: 13px;\n        line-height: 15px;\n    }   \n    \n    .profile-tournaments-teams-summary-modal__table-body__container {\n        padding-left: 0;\n        padding-right: 10px;\n    }\n\n    .profile-tournaments-teams-summary-modal__table-body-col__info__labels {\n        gap: 2px;\n    }\n\n    .profile-tournaments-teams-summary-modal__table-header-col.baloa-normal-medium {\n        font-size: 13px;\n        line-height: 15px;\n    }\n\n    .profile-tournaments-teams-summary-modal__victories__table-header .baloa-normal-medium {\n        font-size: 13px;\n        line-height: 15px;\n    }\n\n    .profile-tournaments-teams-summary-modal__victories__table-body-col__img img {\n        width: 30px;\n        height: 30px;\n    }\n\n    .profile-tournaments-teams-summary-modal__victories__table-body-col__img .icon-ball {\n        font-size: 24px;\n        padding: 3px;    \n    }\n\n    .profile-tournaments-teams-summary-modal__victories__table-body-col__info .baloa-normal-medium {\n        font-size: 14px;\n        line-height: 16px;\n    }\n\n    .profile-tournaments-teams-summary-modal__victories__table-body-col__info__labels .baloa-table-column {\n        font-size: 9px;\n        line-height: 11px;\n        padding: 2px 4px;\n    }\n\n    .profile-tournaments-teams-summary-modal__victories__table-body-col.baloa-normal-medium {\n        font-size: 14px;\n        line-height: 16px;\n    }\n\n    .profile-tournaments-teams-summary-modal__table-container {\n        padding: 0 8px;\n        background-color: var(--white-color);\n    }\n\n    .profile-tournaments-teams-summary-modal__victories__table-header {        \n        padding: 6px 24px 6px 10px;        \n    }\n\n    .profile-tournaments-teams-summary-modal__unlock-values__text .baloa-normal-medium .hubicon-award_star {\n        font-size: 18px;\n    }\n\n    .profile-tournaments-teams-summary-modal__unlock-values__text .baloa-normal-medium {\n        font-size: 13px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
